export default __webpack_public_path__ + "static/media/discover_feature.b0e6c751.png";